import { render, staticRenderFns } from "./deleteNews.vue?vue&type=template&id=be0d7506&scoped=true&"
import script from "./deleteNews.vue?vue&type=script&lang=js&"
export * from "./deleteNews.vue?vue&type=script&lang=js&"
import style0 from "./deleteNews.vue?vue&type=style&index=0&id=be0d7506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0d7506",
  null
  
)

export default component.exports